/**
 * Offline indicator (PWA_PLAN Stage 1).
 *
 * When the device is offline, pages still render the service worker's
 * last-synced API responses — this banner makes that state honest instead
 * of silently showing stale data as live.
 */

import { useEffect, useState } from 'react';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="bg-amber-100 border-b border-amber-200 text-amber-800 text-center text-xs font-medium py-1.5 px-4">
      Offline. Showing your last-synced schedule. Changes are disabled until
      you're back online.
    </div>
  );
}
